const checkIfItemIsInView = (
  elem: HTMLElement | null,
  options: {
    fullObject: boolean;
  } = { fullObject: false },
): boolean => {
  const scroll = window.scrollY || window.pageYOffset;

  if (
    elem &&
    // Check if DOMElement is visible in DOM
    !!(elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length)
  ) {
    const boundsTop = elem.getBoundingClientRect().top + scroll;

    const viewport = {
      top: scroll,
      bottom: scroll + window.innerHeight,
    };

    const bounds = {
      top: boundsTop,
      bottom: boundsTop + elem.clientHeight,
    };

    if (options.fullObject) {
      return (
        (bounds.bottom >= viewport.top && bounds.bottom <= viewport.bottom) ||
        (bounds.top <= viewport.bottom && bounds.top >= viewport.top)
      );
    }

    return bounds.bottom >= viewport.top && bounds.top <= viewport.bottom;
  }

  return false;
};

export default checkIfItemIsInView;
